import React, { Component } from 'react';
import { Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import CONFIG from './../../SYSTEM/Config.js'

import QRCode from 'qrcode.react'

import { Request } from "./../../SYSTEM/Request"

import './../../APP/sticker_print.css';

/// REDUX ///
import * as ReduxActions from './../../REDUX/functions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Header from './../../APP/COMPONENTS/Header';
import LeftNav from './../../APP/COMPONENTS/LeftNav';
import Loader from "../COMPONENTS/Loader";
import { openCommentModal, openMarketingModal } from "./../../REDUX/functions";

function mapStateToProps(state, myProps) {
    return {
        USER: state.USER
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(ReduxActions, dispatch)
}


class PrintMassQr extends Component {
    constructor(props) {
        super(props);
        this.state = {
            USER: this.props.USER,
            LOADED: false,
            products: this.getStickers()
        }
    }

    componentDidMount() {
        this.props.disableElements(false);
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.USER !== prevProps.USER) {
            this.setState({ USER: this.props.USER });
        }
    }

    getStickers = () => {
        const data = localStorage.getItem('productsStickers')
        if (data !== null) {
            return JSON.parse(data)
        }

        return []
    }

    beautifyDate = (date) => {
        let parts = date.split('T');
        parts[0] = parts[0].split('-').reverse().join('.');

        return parts[0] + ' ' + parts[1] + ':00'
    }

    get(name) {
        if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(window.location.search))
            return decodeURIComponent(name[1]);
    }

    setNumeric = (value) => {
        return parseFloat(value.replace(',', '.').replace(' ', ''));
    }

    prepareFoodString = (product) => {
        const foodParts = [];

        if (product.bel) {
            foodParts.push('Белок: ' + this.setNumeric(product.bel) + ' г')
        }

        if (product.fats) {
            foodParts.push('Жир: ' + this.setNumeric(product.fats) + ' г')
        }

        if (product.ugl) {
            foodParts.push('Углеводы: ' + this.setNumeric(product.ugl) + ' г')
        }

        if (product.klet) {
            foodParts.push('Клечатка: ' + this.setNumeric(product.klet) + ' г')
        }

        if (product.calories) {
            foodParts.push(this.setNumeric(product.calories) + ' ккал')
        }

        return foodParts.join('; ')
    }

    prepareBarcode = (product) => {
        return 'GD barcode:' + product.barcode + ';date:' + product.manufactured_with_time + ';order:' + product.order_id + ';'///bestbefore:' + this.beautifyDate(this.get('end')) + ';
    }

    renderProductStickers = (product, index) => {
        let stickers = []

        for (let i = 0; i < product.print_amount; i++) {
            const foodData = this.prepareFoodString(product)
            stickers.push(
                <div key={ i } className="productSticker">
                    <div className="productStickerTitle">
                        { product.title }
                    </div>

                    <div className="productStickerRow">
                        <div className="productStickerSostav">
                            <strong>Состав: </strong>{ product.sostav }
                        </div>
                        <div className="productStickerQr">
                            <QRCode
                                id="qrCodeEl"
                                size={ 75 }
                                value={ this.prepareBarcode(product) }
                            />
                        </div>
                    </div>

                    <div className="productStickerFoodData">
                        { foodData.length ? 'Пищевая и энергетическая ценность в 100г.: ' + foodData + '. ' : '' }Масса Нетто: { product.weight * 1000 }г
                    </div>

                    <div className="productStickerStorageData">
                        { product.storage }
                    </div>

                    <div className="productStickerSupplierData">
                        Изготовитель: { product.supplier }
                    </div>



                    <div className="productStickerSupplierData">
                        Дата производства: { product.manufactured_with_time }
                    </div>

                    { product.placement_cell.length ?
                        <div className="productStickerSupplierData">
                            Ячейка: <strong>{ product.placement_cell }</strong>
                        </div>
                        : null }
                </div>
            )
        }

        return stickers
    }

    render() {
        if (!this.state.USER) {
            return <Redirect to="/" />
        }

        return (
            <div>
                <Helmet>
                    <title>Печать QR</title>
                </Helmet>
                <div className="printStickers" id="printStickers">
                    { this.state.products.map((product, index) => {
                        return this.renderProductStickers(product, index)
                    }) }
                </div>
            </div>
        );
    }
}

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(PrintMassQr))
